/** @jsx $jsx */
import { $jsx } from 'framework7';
function framework7Component() {
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">
      <div class="left">
        <a href="#" class="link back">
          <i class="icon icon-back"></i>
          <span class="if-not-md">Back</span>
        </a>
      </div>
      <div class="title">Not found</div>
    </div>
  </div>
  <div class="page-content">
    <div class="block-title">Content not found</div>
    <div class="block block-strong">
      <p>We're sorry</p>
      <p>Selected content is not available.</p>
    </div>
    <div class="block-footer">
      <p>© AppDigCab, 2023-2024 (v2.0)</p>
    </div>
  </div>
</div>
`
    }
    ;
}
framework7Component.id = '955b4fe6bf';
export default framework7Component;